import { jsxs as n, jsx as o } from "react/jsx-runtime";
const i = ({
  width: r,
  height: t,
  className: e
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 20 21",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M16.2493 10.931C16.2493 9.78099 17.1827 8.84766 18.3327 8.84766V8.01432C18.3327 4.68099 17.4993 3.84766 14.166 3.84766H5.83268C2.49935 3.84766 1.66602 4.68099 1.66602 8.01432V8.43099C2.81602 8.43099 3.74935 9.36432 3.74935 10.5143C3.74935 11.6643 2.81602 12.5977 1.66602 12.5977V13.0143C1.66602 16.3477 2.49935 17.181 5.83268 17.181H14.166C17.4993 17.181 18.3327 16.3477 18.3327 13.0143C17.1827 13.0143 16.2493 12.081 16.2493 10.931Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M8.33398 3.84766L8.33398 17.181",
          stroke: "currentColor",
          strokeDasharray: "4.17 4.17",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      )
    ]
  }
);
export {
  i as Content
};
